// extracted by mini-css-extract-plugin
export default {"container":"HW7_container__ShWPX"};